import { render, staticRenderFns } from "./PeriodSettings.vue?vue&type=template&id=a54cfa8a"
import script from "./PeriodSettings.vue?vue&type=script&lang=js"
export * from "./PeriodSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports